<template>
    <div>
        <v-container grid-list-md>
            <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                    <v-select
                        :items="busquedaSel"
                        v-model="busqueda"
                        label="Sección de búsqueda"
                    ></v-select>
                </v-flex>

                <v-flex v-if="busqueda === 1" xs12 sm6 md9>
                    <v-autocomplete
                        v-model="empleado"
                        :items="empleados"
                        label="Empleado(s)"
                        persistent-hint
                    >
                    </v-autocomplete>

                </v-flex>

                <v-flex xs12 sm8 md9 v-else>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md4>
                            <v-menu
                                v-model="inicioCal"
                                :close-on-content-click="false"
                                full-width
                                max-width="290"
                                >
                                <v-text-field
                                    :value="fechaInicioText"
                                    label="Fecha inicial"
                                    slot="activator"
                                    readonly
                                ></v-text-field>
                                <v-date-picker
                                    v-model="fechaInicio"
                                    @change="inicioCal = false"
                                    locale="es"
                                    reactive
                                    :max="inicioMax"
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 sm6 md4>
                            <v-menu
                                v-model="finCal"
                                :close-on-content-click="false"
                                full-width
                                max-width="290"
                                >
                                <v-text-field
                                    :value="fechaFinText"
                                    label="Fecha final"
                                    slot="activator"
                                    readonly
                                ></v-text-field>
                                <v-date-picker
                                    v-model="fechaFin"
                                    @change="finCal = false"
                                    locale="es"
                                    reactive
                                ></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12 sm6 md2>
                    <v-btn depressed small color="primary" @click="buscar()">Buscar</v-btn>
                </v-flex>

            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment'
moment.locale('es');

// import Resultados from './resultados'
// import CalculoHorario from './calculoHorario'

export default {
    name: 'Busqueda',
    props:['empleados'],
    components:{
        // Resultados,
        // CalculoHorario
    },
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "permisos",
            "role"
        ]),
        puedeAgregarHorario(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 205) >= 0 
        },
        fechaInicioText(){
          moment.locale('es');
          return this.fechaInicio ? moment(this.fechaInicio).format('LL') : ''
        },
        fechaFinText(){
          moment.locale('es');
          return this.fechaFin ? moment(this.fechaFin).format('LL') : ''
        },
        inicioMax(){
            if( this.fechaInicio && this.fechaFin ){
                let inicio = moment(this.fechaInicio);
                let fin = moment(this.fechaFin);
                fin.add(-1,'days');
                if( inicio >= fin ){
                    this.fechaInicio = fin.format('YYYY-MM-DD');
                }
                return fin.format('YYYY-MM-DD');
            }else
                return null;
        }
    },
    data() {
        return {
            busqueda: 1,
            busquedaSel: [
                {value:1,text:'Empleado'},
                {value:2,text:'Fechas'}
            ],
            empleado: null,
            empleadoSel: [],
            fechaInicio: moment().add(-1,'days').format('YYYY-MM-DD'),
            inicioCal:false,
            fechaFin: moment().format('YYYY-MM-DD'),
            finCal:false
        }
    },
    beforeMount(){
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        buscar(){
            if( this.busqueda === 1 && this.empleado ){
                this.$emit('buscarEmpleado',this.empleado)
            }
            if( this.busqueda === 2 ){
                this.$emit('buscarRango',this.fechaInicio,this.fechaFin)
            }
            
        }
    }
}
</script>